<script setup>
import { Input, TextArea } from '../ui/Index';
import { useMainStore } from '@/store/main';
import { useApi } from '@/composables/useApi';
import { computed, ref } from 'vue';

const mainStore = useMainStore();

const { setAppointment } = useApi();

const errors    = ref({});
const isAgree   = ref(false);
const disabled  = ref(false);
const isPressed = ref(false);

const userData  = ref({
	firstname : '',
	lastname  : '',
	phone     : '',
	notes     : '',
});

const hasError = computed(() => Object.values(errors.value).some(el => el));

const checkForm = () => {
	if (isPressed.value) {
		if (userData.value.firstname.length < 3)
			errors.value.firstname = 'Минимальная длина имени - 3 символа';
		else
			errors.value.firstname = '';
		if (userData.value.lastname.length < 3)
			errors.value.lastname = 'Минимальная длина фамилии - 3 символа';
		else
			errors.value.lastname = '';
		if (userData.value.phone.trim().length != 18)
			errors.value.phone = 'Неверная длина номера телефона';
		else
			errors.value.phone = '';
	}
};

const handleSubmit = async () => {
	isPressed.value = true;
	checkForm();

	if (mainStore.sesson_id && !hasError.value) {
		const formData = new FormData();
		for (let item in userData.value)
			formData.append(item, userData.value[item]);
		formData.append('session_id', mainStore.sesson_id);

		try {
			disabled.value = true;
			const response = await setAppointment(formData);
			// setAppointment сам ловит ошибку и возвращает undefined
			if (!response) {
				disabled.value = false;
				return;
			}
			mainStore.completeOrder = true;
			mainStore.setNewsletterLink(response.data?.max_deep_link);
			window.completeOrder = true;
		} catch (e) {
			disabled.value = false;
		}
	}
};
</script>
<template>
	<div class="form user-form">
		<div>
			<Input
				class="user__name"
				name="user__name"
				placeholder="Имя"
				v-model:value="userData.firstname"
				@input="checkForm"
				:cyrillic-only="true"
			/>
			<span class="error-label" v-if="errors.firstname">{{ errors.firstname }}</span>
		</div>
		<div>
			<Input
				class="user__last-name"
				name="user__last-name"
				placeholder="Фамилия"
				v-model:value="userData.lastname"
				@input="checkForm"
				:cyrillic-only="true"
			/>
			<span class="error-label" v-if="errors.lastname">{{ errors.lastname }}</span>
		</div>
		<div>
			<Input
				class="user__phone"
				name="user__phone"
				placeholder="+7"
				v-model:value="userData.phone"
				:mask-options="{ mask: '+7 (###) ###-##-##' }"
				@input="checkForm"
			/>
			<span class="error-label" v-if="errors.phone">{{ errors.phone }}</span>
		</div>
		<Input
			class="user__address"
			name="user__address"
			placeholder="Coming soon"
			:disabled="true"
			info-text="В разработке"
		/>
		<TextArea v-model="userData.notes" />
	</div>
	<div class="privacy-policy">
		<input
			id="privacy-policy"
			type="checkbox"
			name="privacy-policy"
			v-model="isAgree"
		>
		<label class="custom-checkbox" for="privacy-policy" />
		<label class="privacy__content" for="privacy-policy">Я согласен(на) на обработку персональных данных и принимаю пользовательское соглашение</label>
	</div>
	<button
		class="long-btn user-form__order"
		:disabled="!isAgree || hasError || disabled"
		@click="handleSubmit"
	>
		Записаться
	</button>
</template>
<style lang='scss'>
.user-form {
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	gap: 20px;
	border-radius: 16px;

	.input-wr {
		position: relative;
		z-index: 2;
	}

	.error-label {
		font-size: 12px;
		position: absolute;
		color: $yellow;
		margin-top: 3px;
	}

	@include mq($tablet) {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(4, 60px);
		gap: 20px 12px;

		.textarea-wr {
			grid-column: 1 / 3;
			grid-row: 3 / 5;
		} 
	}

	@include mq($desktop) {
		grid-template-columns: repeat(3, 1fr);
		grid-template-rows: repeat(2, 60px);
		gap: 20px;

		.textarea-wr {
			grid-column: 3 / 4;
			grid-row: 1 / 3;
		}
	}
}

.privacy-policy {
	width: fit-content;
	margin-top: 20px;
	display: flex;
	gap: 12px;

	.custom-checkbox {
		width: 24px;
		height: 24px;
	}

	.privacy__content {
		width: 90%;
		max-width: 307px;
		font-size: 12px;
		text-align: left;
	}

	@include mq($tablet) { margin-inline: auto }

	@include mq($desktop) {
		width: 424px;

		.privacy__content {
			max-width: 358px;
			font-size: 14px;
		}

		.custom-checkbox {
			width: 32px;
			height: 32px;
			border-radius: 8px;
		}
	}
}

.user-form__order {
	display: block;
	margin-top: 20px;

	@include mq($tablet) { margin-inline: auto }
}
</style>